import { lazy } from "react";
import type { WidgetDefinition } from "../types";

export interface NightSkyConfig {
  showPlanets: boolean;
  showMeteors: boolean;
  showIss: boolean;
}

// astronomy-engine and satellite.js load only when this card is on screen.
const NightSkyView = lazy(() => import("./NightSkyView"));

export const nightSkyWidget: WidgetDefinition<NightSkyConfig> = {
  type: "night-sky",
  version: 1,
  name: "Tonight’s sky",
  description: "Planets you can see tonight, active meteor showers, and when the Space Station flies over.",
  icon: "sparkle",
  category: "weather",
  defaultSize: { w: 4, h: 6 },
  minSize: { w: 3, h: 3 },
  stackHeight: 520,
  defaults: { showPlanets: true, showMeteors: true, showIss: true },
  settings: [
    { key: "showPlanets", label: "Planets", type: "toggle" },
    { key: "showMeteors", label: "Meteor showers", type: "toggle" },
    { key: "showIss", label: "Space Station passes", type: "toggle", help: "Orbit data from CelesTrak, refreshed a few times a day." },
  ],
  provider: "celestrak",
  capabilities: { requiresLocation: true },
  supportsFullscreen: true,
  Component: NightSkyView,
};
